export class LocalStorageService {
    private key: string = "study-inspirator";

    public read(): any {
        let item: any = localStorage.getItem(this.key);
        return item ? JSON.parse(item) : null;
    }
    
    public write(data: any): void {
        let text: string = JSON.stringify(data);
        localStorage.setItem(this.key, text);
    }
    
    public remove(): void {
        localStorage.removeItem(this.key);
    }
}